const ComunicateSellSection = ({ name, children }) => {
  return (
    <div className="border border-gray-300 rounded-md px-3 pt-3 pb-5 shadow-sm mt-7">
      <h1 className="mb-3 font-semibold text-green-600 -mt-6 md:-mt-7 bg-white w-fit px-2 text-base md:text-lg">
        {name}
      </h1>
      {children}
    </div>
  );
};

export default ComunicateSellSection;
